import type { RoleType } from '../types';

// 由 data/role_checklist_map.csv 決定順序
export const ROLE_ORDER: RoleType[] = [
  "day",
  "night",
  "committee",
  "resident"
];

// Each role's checklist display order, as defined in role_checklist_map.csv (source column order)
export const ROLE_CHECKLIST_ORDER: Record<RoleType, string[]> = {
  "day": [
    "日班",
    "夜班",
    "全日"
  ],
  "night": [
    "夜班",
    "日班",
    "全日"
  ],
  "committee": [
    "全日",
    "日班",
    "夜班",
    "住戶須知"
  ],
  "resident": [
    "住戶須知"
  ]
};
